import { shared, styled, theme } from 'style'

const tokenClass = '& .token.'

export const PreStyled = styled('pre', {
  ...shared.scrollBars({}),

  size: '100%',
  whiteSpace: 'pre',
  wordSpacing: 'normal',
  wordBreak: 'normal',
  wordWrap: 'normal',
  tabSize: 4,
  hyphens: 'none',
  overflow: 'auto',
  lineHeight: '$md',

  '&:focus': { outline: 'none' },

  code: {
    color: '#7D791A',
    '.dark &': {
      color: '#FFFFFF',
    },
    fontFamily: '$mono',
    fontSize: '$sm',
    lineHeight: '$md',
  },

  $$white: '#000000',
  $$gray: '#B3B3B3',
  $$green: '#009D4B',
  $$blue: '#1077B0',
  $$pink: '#EC1118',

  '.dark &': {
    $$white: '#FFFFFF',
    $$gray: '#787C7A',
    $$green: '#67C795',
    $$blue: '#7DD0FF',
    $$pink: '#F98286',
  },

  '.language-': {
    '&js, &jsx, &ts, &tsx, &html, &rust, &swift, &kotlin, &xml, &sql, &json, &yml, &yaml, &bash, &toml':
      {
        [tokenClass]: {
          '&comment,&prolog,&cdata': {
            color: '$$gray',
          },
          '&keyword': {
            color: '$$blue',
          },
          '&delimiter,&boolean,&selector,&important,&atrule': {
            color: '$$green',
          },
          '&operator,&punctuation,&attr-name': {
            color: '$$gray',
          },
          '&tag,&tag .punctuation,&doctype,&builtin': {
            color: '$$green',
          },
          '&entity,&number,&symbol': {
            color: '$$green',
          },
          '&property,&constant,&variable': {
            color: '$$white',
          },
          '&string,&char': {
            color: '$$green',
          },
          '&attr-value,&attr-value .punctuation': {
            color: '$$green',
          },
          '&url': {
            color: '$$green',
            'text-decoration': 'underline',
          },
          '&function': {
            color: '$$pink',
          },
          '&regex': {
            background: '$$green',
          },
        },
      },
    '&graphql, &diff-graphql': {
      [tokenClass]: {
        '&punctuation, &comment, &operator': {
          color: '$$gray',
        },
        '&keyword': {
          color: '$$blue',
        },
        '&type, &literal, &class-name, &scalar, &constant, &definition-query, &definition-mutation':
          {
            color: '$$green',
          },
        '&string, &number, &boolean': {
          color: '$$green',
        },
        '&variable': {
          color: '$$pink',
        },
        '&symbol, &attr-name, &property, &property-query, &property-mutation, &object':
          {
            color: '$$white',
          },
        '&meta, &directive.function': {
          color: '$$pink',
        },
      },
    },
  },

  /**
   * Inspired by gatsby remark prism - https://www.gatsbyjs.com/plugins/gatsby-remark-prismjs/
   * 1. Make the element just wide enough to fit its content.
   * 2. Always fill the visible space in .code-highlight.
   */
  '.code-highlight': {
    float: 'left', // 1
    minWidth: '100%', // 2
  },

  '.code-line': {
    display: 'block',
    width: '$full',
    px: '$4',
    borderLeft: '4px solid rgba(0, 0, 0, 0)', // Set placeholder for highlight accent border color to transparent
  },

  '.code-line.inserted': {
    bgc: '#125634',
    color: '#B0E5CB',
  },

  '.code-line.deleted': {
    bgc: '#732F2F',
    color: '#FBB6B6',
  },

  '.highlight-line': {
    bgc: `${theme.colors.success.value}40`, // Set highlight bg color with 25% opacity
    borderLeft: '4px solid $success', // Set highlight accent border color
  },

  '.line-number::before': {
    display: 'inline-block',
    width: '1.5rem',
    textAlign: 'right',
    marginRight: '$4',
    marginLeft: '-$2',
    color: '$text2',
    content: 'attr(line)',
  },
})
